/* eslint-disable */
//@ts-nocheck
// source: freeform.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var freeform_v1_pb = require('./freeform_v1_pb.js');
goog.object.extend(proto, freeform_v1_pb);
var freeform_v2_pb = require('./freeform_v2_pb.js');
goog.object.extend(proto, freeform_v2_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.freeform.FFChat', null, global);
goog.exportSymbol('proto.freeform.FFChat.PkCase', null, global);
goog.exportSymbol('proto.freeform.FFObject', null, global);
goog.exportSymbol('proto.freeform.FFObject.ContentCase', null, global);
goog.exportSymbol('proto.freeform.GetObjectRequest', null, global);
goog.exportSymbol('proto.freeform.ListObjectsRequest', null, global);
goog.exportSymbol('proto.freeform.ListObjectsResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.freeform.FFChat = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.freeform.FFChat.oneofGroups_);
};
goog.inherits(proto.freeform.FFChat, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.freeform.FFChat.displayName = 'proto.freeform.FFChat';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.freeform.ListObjectsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.freeform.ListObjectsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.freeform.ListObjectsRequest.displayName = 'proto.freeform.ListObjectsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.freeform.ListObjectsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.freeform.ListObjectsResponse.repeatedFields_, null);
};
goog.inherits(proto.freeform.ListObjectsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.freeform.ListObjectsResponse.displayName = 'proto.freeform.ListObjectsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.freeform.GetObjectRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.freeform.GetObjectRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.freeform.GetObjectRequest.displayName = 'proto.freeform.GetObjectRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.freeform.FFObject = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.freeform.FFObject.oneofGroups_);
};
goog.inherits(proto.freeform.FFObject, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.freeform.FFObject.displayName = 'proto.freeform.FFObject';
}

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.freeform.FFChat.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.freeform.FFChat.PkCase = {
  PK_NOT_SET: 0,
  ID: 1,
  UUID: 2
};

/**
 * @return {proto.freeform.FFChat.PkCase}
 */
proto.freeform.FFChat.prototype.getPkCase = function() {
  return /** @type {proto.freeform.FFChat.PkCase} */(jspb.Message.computeOneofCase(this, proto.freeform.FFChat.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.freeform.FFChat.prototype.toObject = function(opt_includeInstance) {
  return proto.freeform.FFChat.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.freeform.FFChat} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.freeform.FFChat.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    uuid: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.freeform.FFChat}
 */
proto.freeform.FFChat.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.freeform.FFChat;
  return proto.freeform.FFChat.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.freeform.FFChat} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.freeform.FFChat}
 */
proto.freeform.FFChat.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.freeform.FFChat.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.freeform.FFChat.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.freeform.FFChat} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.freeform.FFChat.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {number}
 */
proto.freeform.FFChat.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.freeform.FFChat} returns this
 */
proto.freeform.FFChat.prototype.setId = function(value) {
  return jspb.Message.setOneofField(this, 1, proto.freeform.FFChat.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.freeform.FFChat} returns this
 */
proto.freeform.FFChat.prototype.clearId = function() {
  return jspb.Message.setOneofField(this, 1, proto.freeform.FFChat.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.freeform.FFChat.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string uuid = 2;
 * @return {string}
 */
proto.freeform.FFChat.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.freeform.FFChat} returns this
 */
proto.freeform.FFChat.prototype.setUuid = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.freeform.FFChat.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.freeform.FFChat} returns this
 */
proto.freeform.FFChat.prototype.clearUuid = function() {
  return jspb.Message.setOneofField(this, 2, proto.freeform.FFChat.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.freeform.FFChat.prototype.hasUuid = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.freeform.ListObjectsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.freeform.ListObjectsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.freeform.ListObjectsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.freeform.ListObjectsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    chat: jspb.Message.getFieldWithDefault(msg, 1, 0),
    creator: jspb.Message.getFieldWithDefault(msg, 2, 0),
    minY: jspb.Message.getFieldWithDefault(msg, 3, 0),
    maxY: jspb.Message.getFieldWithDefault(msg, 4, 0),
    createdBefore: (f = msg.getCreatedBefore()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    createdAfter: (f = msg.getCreatedAfter()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    pageSize: jspb.Message.getFieldWithDefault(msg, 7, 0),
    page: jspb.Message.getFieldWithDefault(msg, 8, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.freeform.ListObjectsRequest}
 */
proto.freeform.ListObjectsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.freeform.ListObjectsRequest;
  return proto.freeform.ListObjectsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.freeform.ListObjectsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.freeform.ListObjectsRequest}
 */
proto.freeform.ListObjectsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setChat(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setCreator(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setMinY(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setMaxY(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedBefore(value);
      break;
    case 6:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAfter(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setPageSize(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setPage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.freeform.ListObjectsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.freeform.ListObjectsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.freeform.ListObjectsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.freeform.ListObjectsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChat();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getCreator();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getMinY();
  if (f !== 0) {
    writer.writeUint64(
      3,
      f
    );
  }
  f = message.getMaxY();
  if (f !== 0) {
    writer.writeUint64(
      4,
      f
    );
  }
  f = message.getCreatedBefore();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCreatedAfter();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeUint64(
      7,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeUint64(
      8,
      f
    );
  }
};


/**
 * optional uint64 chat = 1;
 * @return {number}
 */
proto.freeform.ListObjectsRequest.prototype.getChat = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.freeform.ListObjectsRequest} returns this
 */
proto.freeform.ListObjectsRequest.prototype.setChat = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint64 creator = 2;
 * @return {number}
 */
proto.freeform.ListObjectsRequest.prototype.getCreator = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.freeform.ListObjectsRequest} returns this
 */
proto.freeform.ListObjectsRequest.prototype.setCreator = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint64 min_y = 3;
 * @return {number}
 */
proto.freeform.ListObjectsRequest.prototype.getMinY = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.freeform.ListObjectsRequest} returns this
 */
proto.freeform.ListObjectsRequest.prototype.setMinY = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint64 max_y = 4;
 * @return {number}
 */
proto.freeform.ListObjectsRequest.prototype.getMaxY = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.freeform.ListObjectsRequest} returns this
 */
proto.freeform.ListObjectsRequest.prototype.setMaxY = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional google.protobuf.Timestamp created_before = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.freeform.ListObjectsRequest.prototype.getCreatedBefore = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.freeform.ListObjectsRequest} returns this
*/
proto.freeform.ListObjectsRequest.prototype.setCreatedBefore = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.freeform.ListObjectsRequest} returns this
 */
proto.freeform.ListObjectsRequest.prototype.clearCreatedBefore = function() {
  return this.setCreatedBefore(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.freeform.ListObjectsRequest.prototype.hasCreatedBefore = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.Timestamp created_after = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.freeform.ListObjectsRequest.prototype.getCreatedAfter = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.freeform.ListObjectsRequest} returns this
*/
proto.freeform.ListObjectsRequest.prototype.setCreatedAfter = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.freeform.ListObjectsRequest} returns this
 */
proto.freeform.ListObjectsRequest.prototype.clearCreatedAfter = function() {
  return this.setCreatedAfter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.freeform.ListObjectsRequest.prototype.hasCreatedAfter = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional uint64 page_size = 7;
 * @return {number}
 */
proto.freeform.ListObjectsRequest.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.freeform.ListObjectsRequest} returns this
 */
proto.freeform.ListObjectsRequest.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional uint64 page = 8;
 * @return {number}
 */
proto.freeform.ListObjectsRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.freeform.ListObjectsRequest} returns this
 */
proto.freeform.ListObjectsRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.freeform.ListObjectsResponse.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.freeform.ListObjectsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.freeform.ListObjectsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.freeform.ListObjectsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.freeform.ListObjectsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    count: jspb.Message.getFieldWithDefault(msg, 1, 0),
    next: jspb.Message.getFieldWithDefault(msg, 2, ""),
    previous: jspb.Message.getFieldWithDefault(msg, 3, ""),
    resultsList: jspb.Message.toObjectList(msg.getResultsList(),
    proto.freeform.FFObject.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.freeform.ListObjectsResponse}
 */
proto.freeform.ListObjectsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.freeform.ListObjectsResponse;
  return proto.freeform.ListObjectsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.freeform.ListObjectsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.freeform.ListObjectsResponse}
 */
proto.freeform.ListObjectsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setCount(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNext(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrevious(value);
      break;
    case 4:
      var value = new proto.freeform.FFObject;
      reader.readMessage(value,proto.freeform.FFObject.deserializeBinaryFromReader);
      msg.addResults(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.freeform.ListObjectsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.freeform.ListObjectsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.freeform.ListObjectsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.freeform.ListObjectsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCount();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getNext();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPrevious();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getResultsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.freeform.FFObject.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint64 count = 1;
 * @return {number}
 */
proto.freeform.ListObjectsResponse.prototype.getCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.freeform.ListObjectsResponse} returns this
 */
proto.freeform.ListObjectsResponse.prototype.setCount = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string next = 2;
 * @return {string}
 */
proto.freeform.ListObjectsResponse.prototype.getNext = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.freeform.ListObjectsResponse} returns this
 */
proto.freeform.ListObjectsResponse.prototype.setNext = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string previous = 3;
 * @return {string}
 */
proto.freeform.ListObjectsResponse.prototype.getPrevious = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.freeform.ListObjectsResponse} returns this
 */
proto.freeform.ListObjectsResponse.prototype.setPrevious = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated FFObject results = 4;
 * @return {!Array<!proto.freeform.FFObject>}
 */
proto.freeform.ListObjectsResponse.prototype.getResultsList = function() {
  return /** @type{!Array<!proto.freeform.FFObject>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.freeform.FFObject, 4));
};


/**
 * @param {!Array<!proto.freeform.FFObject>} value
 * @return {!proto.freeform.ListObjectsResponse} returns this
*/
proto.freeform.ListObjectsResponse.prototype.setResultsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.freeform.FFObject=} opt_value
 * @param {number=} opt_index
 * @return {!proto.freeform.FFObject}
 */
proto.freeform.ListObjectsResponse.prototype.addResults = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.freeform.FFObject, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.freeform.ListObjectsResponse} returns this
 */
proto.freeform.ListObjectsResponse.prototype.clearResultsList = function() {
  return this.setResultsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.freeform.GetObjectRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.freeform.GetObjectRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.freeform.GetObjectRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.freeform.GetObjectRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    uuid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.freeform.GetObjectRequest}
 */
proto.freeform.GetObjectRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.freeform.GetObjectRequest;
  return proto.freeform.GetObjectRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.freeform.GetObjectRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.freeform.GetObjectRequest}
 */
proto.freeform.GetObjectRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.freeform.GetObjectRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.freeform.GetObjectRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.freeform.GetObjectRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.freeform.GetObjectRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.freeform.GetObjectRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.freeform.GetObjectRequest} returns this
 */
proto.freeform.GetObjectRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.freeform.FFObject.oneofGroups_ = [[7,8,14]];

/**
 * @enum {number}
 */
proto.freeform.FFObject.ContentCase = {
  CONTENT_NOT_SET: 0,
  TEXT: 7,
  ASSET: 8,
  NEW_TEXT: 14
};

/**
 * @return {proto.freeform.FFObject.ContentCase}
 */
proto.freeform.FFObject.prototype.getContentCase = function() {
  return /** @type {proto.freeform.FFObject.ContentCase} */(jspb.Message.computeOneofCase(this, proto.freeform.FFObject.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.freeform.FFObject.prototype.toObject = function(opt_includeInstance) {
  return proto.freeform.FFObject.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.freeform.FFObject} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.freeform.FFObject.toObject = function(includeInstance, msg) {
  var f, obj = {
    creator: jspb.Message.getFieldWithDefault(msg, 1, 0),
    chat: jspb.Message.getFieldWithDefault(msg, 2, 0),
    creatorUuid: msg.getCreatorUuid_asB64(),
    chatUuid: msg.getChatUuid_asB64(),
    created: (f = msg.getCreated()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    transform: (f = msg.getTransform()) && freeform_v2_pb.AffineTransform.toObject(includeInstance, f),
    size: (f = msg.getSize()) && freeform_v2_pb.Size.toObject(includeInstance, f),
    type: jspb.Message.getFieldWithDefault(msg, 6, 0),
    text: (f = msg.getText()) && freeform_v1_pb.FFText.toObject(includeInstance, f),
    asset: (f = msg.getAsset()) && freeform_v1_pb.FFAsset.toObject(includeInstance, f),
    newText: (f = msg.getNewText()) && freeform_v2_pb.TextContentV2.toObject(includeInstance, f),
    avatar: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
    autoposition: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
    isBackground: jspb.Message.getBooleanFieldWithDefault(msg, 13, false),
    uuid: jspb.Message.getFieldWithDefault(msg, 11, ""),
    dedupeUuid: jspb.Message.getFieldWithDefault(msg, 110, ""),
    version: jspb.Message.getFieldWithDefault(msg, 12, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.freeform.FFObject}
 */
proto.freeform.FFObject.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.freeform.FFObject;
  return proto.freeform.FFObject.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.freeform.FFObject} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.freeform.FFObject}
 */
proto.freeform.FFObject.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setCreator(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setChat(value);
      break;
    case 120:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setCreatorUuid(value);
      break;
    case 121:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setChatUuid(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreated(value);
      break;
    case 4:
      var value = new freeform_v2_pb.AffineTransform;
      reader.readMessage(value,freeform_v2_pb.AffineTransform.deserializeBinaryFromReader);
      msg.setTransform(value);
      break;
    case 5:
      var value = new freeform_v2_pb.Size;
      reader.readMessage(value,freeform_v2_pb.Size.deserializeBinaryFromReader);
      msg.setSize(value);
      break;
    case 6:
      var value = /** @type {!proto.freeform.ObjectType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 7:
      var value = new freeform_v1_pb.FFText;
      reader.readMessage(value,freeform_v1_pb.FFText.deserializeBinaryFromReader);
      msg.setText(value);
      break;
    case 8:
      var value = new freeform_v1_pb.FFAsset;
      reader.readMessage(value,freeform_v1_pb.FFAsset.deserializeBinaryFromReader);
      msg.setAsset(value);
      break;
    case 14:
      var value = new freeform_v2_pb.TextContentV2;
      reader.readMessage(value,freeform_v2_pb.TextContentV2.deserializeBinaryFromReader);
      msg.setNewText(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAvatar(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAutoposition(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsBackground(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    case 110:
      var value = /** @type {string} */ (reader.readString());
      msg.setDedupeUuid(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.freeform.FFObject.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.freeform.FFObject.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.freeform.FFObject} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.freeform.FFObject.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCreator();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getChat();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getCreatorUuid_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      120,
      f
    );
  }
  f = message.getChatUuid_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      121,
      f
    );
  }
  f = message.getCreated();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getTransform();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      freeform_v2_pb.AffineTransform.serializeBinaryToWriter
    );
  }
  f = message.getSize();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      freeform_v2_pb.Size.serializeBinaryToWriter
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getText();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      freeform_v1_pb.FFText.serializeBinaryToWriter
    );
  }
  f = message.getAsset();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      freeform_v1_pb.FFAsset.serializeBinaryToWriter
    );
  }
  f = message.getNewText();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      freeform_v2_pb.TextContentV2.serializeBinaryToWriter
    );
  }
  f = message.getAvatar();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getAutoposition();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getIsBackground();
  if (f) {
    writer.writeBool(
      13,
      f
    );
  }
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getDedupeUuid();
  if (f.length > 0) {
    writer.writeString(
      110,
      f
    );
  }
  f = message.getVersion();
  if (f !== 0) {
    writer.writeUint64(
      12,
      f
    );
  }
};


/**
 * optional uint64 creator = 1;
 * @return {number}
 */
proto.freeform.FFObject.prototype.getCreator = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.freeform.FFObject} returns this
 */
proto.freeform.FFObject.prototype.setCreator = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint64 chat = 2;
 * @return {number}
 */
proto.freeform.FFObject.prototype.getChat = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.freeform.FFObject} returns this
 */
proto.freeform.FFObject.prototype.setChat = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional bytes creator_uuid = 120;
 * @return {!(string|Uint8Array)}
 */
proto.freeform.FFObject.prototype.getCreatorUuid = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 120, ""));
};


/**
 * optional bytes creator_uuid = 120;
 * This is a type-conversion wrapper around `getCreatorUuid()`
 * @return {string}
 */
proto.freeform.FFObject.prototype.getCreatorUuid_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getCreatorUuid()));
};


/**
 * optional bytes creator_uuid = 120;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getCreatorUuid()`
 * @return {!Uint8Array}
 */
proto.freeform.FFObject.prototype.getCreatorUuid_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getCreatorUuid()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.freeform.FFObject} returns this
 */
proto.freeform.FFObject.prototype.setCreatorUuid = function(value) {
  return jspb.Message.setProto3BytesField(this, 120, value);
};


/**
 * optional bytes chat_uuid = 121;
 * @return {!(string|Uint8Array)}
 */
proto.freeform.FFObject.prototype.getChatUuid = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 121, ""));
};


/**
 * optional bytes chat_uuid = 121;
 * This is a type-conversion wrapper around `getChatUuid()`
 * @return {string}
 */
proto.freeform.FFObject.prototype.getChatUuid_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getChatUuid()));
};


/**
 * optional bytes chat_uuid = 121;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getChatUuid()`
 * @return {!Uint8Array}
 */
proto.freeform.FFObject.prototype.getChatUuid_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getChatUuid()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.freeform.FFObject} returns this
 */
proto.freeform.FFObject.prototype.setChatUuid = function(value) {
  return jspb.Message.setProto3BytesField(this, 121, value);
};


/**
 * optional google.protobuf.Timestamp created = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.freeform.FFObject.prototype.getCreated = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.freeform.FFObject} returns this
*/
proto.freeform.FFObject.prototype.setCreated = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.freeform.FFObject} returns this
 */
proto.freeform.FFObject.prototype.clearCreated = function() {
  return this.setCreated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.freeform.FFObject.prototype.hasCreated = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional AffineTransform transform = 4;
 * @return {?proto.freeform.AffineTransform}
 */
proto.freeform.FFObject.prototype.getTransform = function() {
  return /** @type{?proto.freeform.AffineTransform} */ (
    jspb.Message.getWrapperField(this, freeform_v2_pb.AffineTransform, 4));
};


/**
 * @param {?proto.freeform.AffineTransform|undefined} value
 * @return {!proto.freeform.FFObject} returns this
*/
proto.freeform.FFObject.prototype.setTransform = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.freeform.FFObject} returns this
 */
proto.freeform.FFObject.prototype.clearTransform = function() {
  return this.setTransform(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.freeform.FFObject.prototype.hasTransform = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Size size = 5;
 * @return {?proto.freeform.Size}
 */
proto.freeform.FFObject.prototype.getSize = function() {
  return /** @type{?proto.freeform.Size} */ (
    jspb.Message.getWrapperField(this, freeform_v2_pb.Size, 5));
};


/**
 * @param {?proto.freeform.Size|undefined} value
 * @return {!proto.freeform.FFObject} returns this
*/
proto.freeform.FFObject.prototype.setSize = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.freeform.FFObject} returns this
 */
proto.freeform.FFObject.prototype.clearSize = function() {
  return this.setSize(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.freeform.FFObject.prototype.hasSize = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional ObjectType type = 6;
 * @return {!proto.freeform.ObjectType}
 */
proto.freeform.FFObject.prototype.getType = function() {
  return /** @type {!proto.freeform.ObjectType} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.freeform.ObjectType} value
 * @return {!proto.freeform.FFObject} returns this
 */
proto.freeform.FFObject.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional FFText text = 7;
 * @return {?proto.freeform.FFText}
 */
proto.freeform.FFObject.prototype.getText = function() {
  return /** @type{?proto.freeform.FFText} */ (
    jspb.Message.getWrapperField(this, freeform_v1_pb.FFText, 7));
};


/**
 * @param {?proto.freeform.FFText|undefined} value
 * @return {!proto.freeform.FFObject} returns this
*/
proto.freeform.FFObject.prototype.setText = function(value) {
  return jspb.Message.setOneofWrapperField(this, 7, proto.freeform.FFObject.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.freeform.FFObject} returns this
 */
proto.freeform.FFObject.prototype.clearText = function() {
  return this.setText(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.freeform.FFObject.prototype.hasText = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional FFAsset asset = 8;
 * @return {?proto.freeform.FFAsset}
 */
proto.freeform.FFObject.prototype.getAsset = function() {
  return /** @type{?proto.freeform.FFAsset} */ (
    jspb.Message.getWrapperField(this, freeform_v1_pb.FFAsset, 8));
};


/**
 * @param {?proto.freeform.FFAsset|undefined} value
 * @return {!proto.freeform.FFObject} returns this
*/
proto.freeform.FFObject.prototype.setAsset = function(value) {
  return jspb.Message.setOneofWrapperField(this, 8, proto.freeform.FFObject.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.freeform.FFObject} returns this
 */
proto.freeform.FFObject.prototype.clearAsset = function() {
  return this.setAsset(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.freeform.FFObject.prototype.hasAsset = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional TextContentV2 new_text = 14;
 * @return {?proto.freeform.TextContentV2}
 */
proto.freeform.FFObject.prototype.getNewText = function() {
  return /** @type{?proto.freeform.TextContentV2} */ (
    jspb.Message.getWrapperField(this, freeform_v2_pb.TextContentV2, 14));
};


/**
 * @param {?proto.freeform.TextContentV2|undefined} value
 * @return {!proto.freeform.FFObject} returns this
*/
proto.freeform.FFObject.prototype.setNewText = function(value) {
  return jspb.Message.setOneofWrapperField(this, 14, proto.freeform.FFObject.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.freeform.FFObject} returns this
 */
proto.freeform.FFObject.prototype.clearNewText = function() {
  return this.setNewText(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.freeform.FFObject.prototype.hasNewText = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional bool avatar = 9;
 * @return {boolean}
 */
proto.freeform.FFObject.prototype.getAvatar = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.freeform.FFObject} returns this
 */
proto.freeform.FFObject.prototype.setAvatar = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * optional bool autoposition = 10;
 * @return {boolean}
 */
proto.freeform.FFObject.prototype.getAutoposition = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.freeform.FFObject} returns this
 */
proto.freeform.FFObject.prototype.setAutoposition = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional bool is_background = 13;
 * @return {boolean}
 */
proto.freeform.FFObject.prototype.getIsBackground = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/**
 * @param {boolean} value
 * @return {!proto.freeform.FFObject} returns this
 */
proto.freeform.FFObject.prototype.setIsBackground = function(value) {
  return jspb.Message.setProto3BooleanField(this, 13, value);
};


/**
 * optional string uuid = 11;
 * @return {string}
 */
proto.freeform.FFObject.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.freeform.FFObject} returns this
 */
proto.freeform.FFObject.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string dedupe_uuid = 110;
 * @return {string}
 */
proto.freeform.FFObject.prototype.getDedupeUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 110, ""));
};


/**
 * @param {string} value
 * @return {!proto.freeform.FFObject} returns this
 */
proto.freeform.FFObject.prototype.setDedupeUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 110, value);
};


/**
 * optional uint64 version = 12;
 * @return {number}
 */
proto.freeform.FFObject.prototype.getVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.freeform.FFObject} returns this
 */
proto.freeform.FFObject.prototype.setVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


goog.object.extend(exports, proto.freeform);
